import React, { useEffect, useState } from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
  Grid,
  Button,
  Fab,
} from '@material-ui/core';
import TableBody from '@material-ui/core/TableBody';
import TablePagination from '@material-ui/core/TablePagination';
import LoadListRow from './LoadListRow';
import LoadTableHead from './LoadTableHead';
import LoadTableToolbar from './LoadTableToolbar';
import { getComparator, stableSort } from '../../../@jumbo/utils/tableHelper';
import { useDispatch, useSelector } from 'react-redux';
import {
  bidLoad,
  bookLoad,
  getFilters,
  getLoadFilter,
  getLoads,
  moveLoadsToRequests,
  setCurrentLoad,
  updateLoadFilter,
} from '../../../redux/actions/Loads';
import AddEditLoadFilter from './AddEditLoadFilter';
import ConfirmDialog from '../../../@jumbo/components/Common/ConfirmDialog';
import { getUserPermissions, useDebounce } from '../../../@jumbo/utils/commonHelper';
import useStyles from './index.style';
import LoadDetailView from './LoadDetailView';
import NoRecordFound from './NoRecordFound';
import copy from 'copy-to-clipboard';
import LoadTab from './LoadTab';
import UploadDedicatedLoadsDialog from './DedicatedLoads/UploadDedicatedLoadsDialog';
import DedicatedLoadTableHead from './DedicatedLoads/DedicatedLoadTableHead';
import DedicatedLoadListRow from './DedicatedLoads/DedicatedLoadListRow';
import styles from '../../../styles/loadboard.module.scss';
import FilterListRow from './LoadListRow/FilterListRow';
import moment from 'moment';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import Select from 'react-select';
import RecentSearchCardView from './RecentSearchCardView';
import tripStyles from '../../../styles/tripschedular.module.scss';
import { useHistory, useLocation } from 'react-router';
import LoadSearch from './LoadSearch';
import { Refresh } from '@material-ui/icons';
import LoadsListShimmer from './LoadsListShimmer';

const sortByOptions = [
  { value: 'row_updated_at', label: 'Age' },
  { value: 'distance_origin', label: 'DH/O' },
  { value: 'rate', label: 'Rate' },
  // { value: 'pick_up_date', label: 'Pickup Date' },
];

const Loadboard = () => {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const { loads, currentLoadFilter, totalLoads, filters, totalFilters } = useSelector(({ loadsReducer }) => loadsReducer);
  const [orderBy, setOrderBy] = React.useState('name');
  const [order, setOrder] = React.useState('asc');
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [callDialog, setCallDialog] = useState(false);
  const [bidValue, setBidValue] = useState(0);
  const [bidDialog, setBidDialog] = useState(false);
  const [bidValueError, setBidValueError] = useState(false);
  const [selectedLoad, setSelectedLoad] = useState({ name: '' });
  const [loadsFetched, setLoadsFetched] = useState(false);
  const [isFilterApplied, setFilterApplied] = useState(false);
  const [filterOptions, setFilterOptions] = React.useState({});
  const [uploadDialogOpen, setUploadDialogOpen] = useState(false);
  const [currentTab, setCurrentTab] = useState(1);
  const [copyClicked, setCopyClicked] = useState(false);
  const permissions = getUserPermissions();
  const [sort, setSort] = useState(sortByOptions[0]);
  const dispatch = useDispatch();
  const [openRequestDialog, setOpenRequestDialog] = useState(false);
  const [openRejectDialog, setOpenRejectDialog] = useState(false);

  useEffect(() => {
    if (location && location.search && location.search.includes('2')) {
      dispatch(getLoadFilter());
      setCurrentTab(2);
    } else if (currentTab === 1) {
      handleSavedSearch();
    }
    history.push({ pathname: history.pathname, search: `?${currentTab}` });
  }, [dispatch, currentTab]);

  function handleLoadSearch() {
    setLoadsFetched(false);
    let filter = mapFilter();
    if (filter && filter.type && filter.origin_id) {
      setFilterApplied(true);
      dispatch(getLoads(filter)).then(() => {
        setLoadsFetched(true);
      });
    }
  }

  useEffect(() => {
    if (currentLoadFilter) {
      handleLoadSearch();
    } else {
      if (!localStorage.getItem('load_filter')) {
        handleLoadType('Daily');
      }
    }
  }, [dispatch, currentLoadFilter, page, rowsPerPage, sort]);

  function handleSavedSearch() {
    setLoadsFetched(false);
    dispatch(getFilters()).then(() => {
      setLoadsFetched(true);
    });
    setCurrentTab(1);
  }

  const mapFilter = () => {
    if (currentLoadFilter) {
      var filter = {
        type: currentLoadFilter.loadType,
        origin_id: currentLoadFilter.pickUpValue && currentLoadFilter.pickUpValue.id,
        destination_id: currentLoadFilter.dropOffValue && currentLoadFilter.dropOffValue.id,
        length: currentLoadFilter.lengthValue,
        weight: currentLoadFilter.weightValue,
        start_date: currentLoadFilter.startDate && moment(currentLoadFilter.startDate).format('YYYY-MM-DD'),
        end_date: currentLoadFilter.endDate && moment(currentLoadFilter.endDate).format('YYYY-MM-DD'),
        distance_origin: currentLoadFilter.dho,
        distance_destination: currentLoadFilter.dhd,
        trailer_type: currentLoadFilter.trailerTypes && currentLoadFilter.trailerTypes.map(v => v.value).join(','),
        unique_load_id: currentLoadFilter.unique_load_id,
        sort_by: sort.value,
        start: 1,
        limit: (page + 1) * rowsPerPage,
      };
      if (currentLoadFilter && currentLoadFilter.id) {
        filter['filter_id'] = currentLoadFilter.id;
      }
      Object.keys(filter).forEach(k => filter[k] == null && delete filter[k]);
      return filter;
    }

    return [];
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setFilterOptions(mapFilter());
    dispatch(setCurrentLoad(null));
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrderBy(property);
    setOrder(isAsc ? 'desc' : 'asc');
  };

  const handlePageChange = newPage => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  function handleScroll(e) {
    if (e.currentTarget.scrollHeight - e.currentTarget.scrollTop - e.currentTarget.offsetHeight < 1) {
      if ((page + 1) * rowsPerPage === totalLoads) {
        setPage(page + 1);
      }
    }
  }

  const handleView = load => {
    dispatch(setCurrentLoad(load));
    setOpenViewDialog(true);
  };

  function handleCall(load) {
    setSelectedLoad(load);
    setCallDialog(true);
  }

  function handleBid(load) {
    setSelectedLoad(load);
    setBidDialog(true);
  }

  function handleBidClose() {
    setBidDialog(false);
    setBidValue(0);
    setBidValueError(false);
  }

  function handleCallClose() {
    setCallDialog(false);
  }

  function handleCallCopy() {
    copy(`+1 ${selectedLoad.company_phone}`);
    setCopyClicked(true);
    setTimeout(() => {
      setCopyClicked(false);
    }, [2000]);
  }

  const handleCloseViewDialog = () => {
    setOpenViewDialog(false);
    dispatch(setCurrentLoad(null));
  };

  const handleEdit = load => {
    dispatch(setCurrentLoad(load));
    setOpenDialog(true);
  };

  const handleBook = load => {
    setSelectedLoad(load);
    setOpenConfirmDialog(true);
  };

  const handleConfirmBook = () => {
    setOpenConfirmDialog(false);
    dispatch(bookLoad(selectedLoad.id));
  };

  function handleBidSend() {
    if (!isBidValid(bidValue)) {
      dispatch(bidLoad(selectedLoad.id, { amount: bidValue }));
      setBidDialog(false);
    }
  }

  function isBidValid(value) {
    let flag = false;
    if (parseInt(value) < 1 || parseInt(value) > 99999) {
      setBidValueError(true);
      flag = true;
    }
    return flag;
  }

  const handleCancelDelete = () => {
    setOpenConfirmDialog(false);
    setSelectedLoad({ name: '' });
  };

  function handleBidChange(value) {
    if (value && !value.match(/^[0-9]*$/g)) {
      return;
    }
    if (value && value.length > 5) {
      return;
    }
    setBidValue(value);
  }

  function bidContent() {
    return (
      <React.Fragment>
        <TextField
          id="bid"
          label="Bid Amount"
          variant="outlined"
          size="small"
          fullWidth
          value={bidValue}
          onChange={e => {
            handleBidChange(e.target.value);
          }}
        />
        {bidValueError ? (
          <p style={{ margin: '8px 0 0', color: '#ff0000' }}>Entered bid Value should be between 1 and 99999</p>
        ) : (
          ''
        )}
      </React.Fragment>
    );
  }

  const handleLoadType = value => {
    dispatch(
      updateLoadFilter({ ...currentLoadFilter, loadType: value }, () => {
        setCurrentTab(2);
      }),
    );
  };

  const handleUploadDialogOpen = () => {
    setUploadDialogOpen(true);
  };

  const handleUploadDialogClose = () => {
    setUploadDialogOpen(false);
  };

  function handleApply(filter) {
    let updatedFilter = {};
    updatedFilter['pickUpValue'] = filter.origin;
    if (filter && Object.keys(filter.destination).length) {
      updatedFilter['dropOffValue'] = filter.destination;
    }
    updatedFilter['endDate'] = filter.end_date;
    updatedFilter['lengthValue'] = filter.length;
    updatedFilter['loadType'] = filter.type;
    updatedFilter['startDate'] = filter.start_date;
    if (filter && filter.trailer_type) {
      let trailerTypes = filter.trailer_type.split(',').map(v => ({ value: v, label: v }));
      updatedFilter['trailerTypes'] = trailerTypes;
    }
    updatedFilter['weightValue'] = filter.weight;
    updatedFilter['id'] = filter.id;
    Object.keys(updatedFilter).forEach(k => (updatedFilter[k] == null || updatedFilter[k] === 0) && delete updatedFilter[k]);
    dispatch(
      updateLoadFilter(updatedFilter, () => {
        setCurrentTab(2);
      }),
    );
  }

  const customStyles = {
    container: styles => ({
      ...styles,
      zIndex: 999,
      minWidth: 150,
    }),
  };

  function sortFilter() {
    return (
      <Select
        defaultValue={sort}
        options={sortByOptions}
        onChange={value => {
          setSort(value);
        }}
        styles={customStyles}
        components={{
          IndicatorSeparator: () => null,
        }}
        fullWidth
      />
    );
  }

  function handleSearch(searchText = '') {
    if (searchText && searchText.length) {
      dispatch(getLoads({ unique_load_id: searchText })).then(() => {});
    }
  }

  function handleClear() {
    let updatedFilter = {
      ...currentLoadFilter,
    };
    dispatch(updateLoadFilter(updatedFilter, () => {}));
  }

  const createSearchDialogOpen = () => {
    dispatch(
      updateLoadFilter({ loadType: 'Daily' }, () => {
        setOpenDialog(true);
      }),
    );
  };

  const handleViewRequestedDialog = load => {
    setOpenRequestDialog(true);
    setSelectedLoad(load);
  };

  const handleViewRejectedDialog = load => {
    setOpenRejectDialog(true);
    setSelectedLoad(load);
  };

  const handleCloseRequestedDialog = () => {
    setOpenRequestDialog(false);
    setSelectedLoad({ name: '' });
  };

  const handleCloseRejectedDialog = () => {
    setOpenRejectDialog(false);
    setSelectedLoad({ name: '' });
  };

  function ongoingOrRejectAction(type) {
    let data = {
      request_type: type,
    };
    dispatch(moveLoadsToRequests(selectedLoad.id, data))
      .then(res => {
        handleLoadSearch();
      })
      .catch();
  }

  return (
    <Box>
      <Box className={styles.backToPastSearchBlk}>
        {currentTab === 1 ? (
          <Grid container alignContent="center">
            <Grid item xs={6}>
              <h2>Recent Searches</h2>
            </Grid>
            <Grid item xs={6} className="textRight">
              <Button variant="contained" color="primary" onClick={createSearchDialogOpen}>
                Create New Search
              </Button>
            </Grid>
          </Grid>
        ) : (
          <Grid container alignItems="center">
            <Grid item xs={5}>
              <a
                onClick={() => {
                  history.push({ pathname: history.pathname, search: `?1` });
                  setCurrentTab(1);
                }}>
                <ArrowBackIosIcon />
                <span>Back to Recent Searches</span>
              </a>
            </Grid>
            <Grid item xs={7}>
              <LoadSearch handleSearch={handleSearch} handleClear={handleClear} />
            </Grid>
          </Grid>
        )}
      </Box>
      {currentTab === 2 ? (
        <Box>
          <Box className={styles.refreshBlk} style={{ textAlign: 'right' }}>
            <Fab
              color="primary"
              aria-label="add"
              size="small"
              onClick={() => handleLoadSearch()}
              style={{ position: 'relative', top: '-16px' }}>
              <Refresh />
            </Fab>
          </Box>
          <div className={classes.root + ' ' + styles.loadPageMainWrapper}>
            {/* {currentTab === 2 ? (
            <LoadTab
              currentLoadFilter={currentLoadFilter}
              handleLoadType={handleLoadType}
              handleUploadDialogOpen={handleUploadDialogOpen}
              permissions={permissions}
            />
          ) : (
            ''
          )} */}

            <Paper className={classes.paper + ' ' + styles.loadTableWrapper}>
              {currentTab === 2 ? (
                <LoadTableToolbar
                  currentTab={currentTab}
                  onAddFilter={setOpenDialog}
                  handleSavedSearch={handleSavedSearch}
                  filterOptions={filterOptions}
                  setFilterOptions={setFilterOptions}
                  filter={sortFilter}
                />
              ) : (
                ''
              )}
              <TableContainer className={classes.container} onScroll={handleScroll}>
                <Table
                  stickyHeader
                  className={classes.table}
                  aria-labelledby="tableTitle"
                  aria-label="sticky enhanced table">
                  {currentLoadFilter && currentLoadFilter.loadType == 'Daily' ? (
                    <LoadTableHead
                      classes={classes}
                      order={order}
                      permissions={permissions}
                      orderBy={orderBy}
                      onRequestSort={handleRequestSort}
                      currentTab={currentTab}
                    />
                  ) : (
                    <DedicatedLoadTableHead
                      classes={classes}
                      order={order}
                      orderBy={orderBy}
                      onRequestSort={handleRequestSort}
                      currentTab={currentTab}
                      permissions={permissions}
                    />
                  )}
                  <TableBody>
                    {currentTab === 2 ? (
                      !!loads.length ? (
                        stableSort(loads, getComparator(order, orderBy)).map((row, index) =>
                          currentLoadFilter && currentLoadFilter.loadType == 'Daily' ? (
                              <LoadListRow
                                key={index}
                                row={row}
                                permissions={permissions}
                                currentLoadFilter={currentLoadFilter}
                                onEdit={handleEdit}
                                onLoadBook={handleBook}
                                onCall={handleCall}
                                onView={handleView}
                                onBid={handleBid}
                                onCallRequested={handleViewRequestedDialog}
                                onCallRejected={handleViewRejectedDialog}
                                itemIndex={index}
                              />
                          ) : (
                            <DedicatedLoadListRow
                              key={index}
                              row={row}
                              onLoadBook={handleBook}
                              onCall={handleCall}
                              onBid={handleBid}
                            />
                          ),
                        )
                      ) : (
                        <TableRow style={{ height: 53 * 6 }}>
                          <TableCell colSpan={10} rowSpan={10}>  
                            {isFilterApplied && loadsFetched ? (
                              <NoRecordFound>There are no records found with your filter.</NoRecordFound>
                            ) : !isFilterApplied ? (
                              <NoRecordFound>Apply a filter to see loads.</NoRecordFound>
                            ) : (
                              <Box style={{width: '100%'}}>
                              {
                                [0,1,2,3,4,5,6,7,8].map((item, key) =>
                                  <LoadsListShimmer />
                                )
                              }
                              </Box>
                              // <NoRecordFound>{'Fetching Loads...'}</NoRecordFound>
                            )}
                          </TableCell>
                        </TableRow>
                      )
                    ) : (
                      // (
                      //   // : !!filters.length ? (
                      //   //   stableSort(filters, getComparator(order, orderBy)).map((row, index) => (
                      //   //     // <FilterListRow key={index} row={row} handleApply={handleApply} />
                      //   //     <RecentSearchCardView />
                      //   //   ))
                      //   // )
                      //   <TableRow style={{ height: 53 * 6 }}>
                      //     <TableCell colSpan={10} rowSpan={10}>
                      //       {loadsFetched ? (
                      //         <NoRecordFound>{'You have Created No filters Yet!'}</NoRecordFound>
                      //       ) : (
                      //         <NoRecordFound>{'Fetching Filters...'}</NoRecordFound>
                      //       )}
                      //     </TableCell>
                      //   </TableRow>
                      // )
                      ''
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              {/* {loads && loads.length >= 200 ? (
              <Box p={4} align="center">
                <Button
                  variant="outlined"
                  color="primary"
                  size="small"
                  disabled={page === 0}
                  onClick={() => {
                    handlePageChange(page - 1);
                  }}>
                  Previous
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  style={{ marginLeft: 12 }}
                  onClick={() => {
                    handlePageChange(page + 1);
                  }}>
                  Next
                </Button>
              </Box>
            ) : null} */}
              {/* <TablePagination
              rowsPerPageOptions={[10, 20, 50]}
              component="div"
              count={currentTab != 2 ? totalFilters : totalLoads}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleRowsPerPageChange}
            /> */}
            </Paper>
          </div>
        </Box>
      ) : (
        <Box className={styles.recentSearchWrapper + ' ' + tripStyles.loadListWrapper}>
          {!!filters.length ? (
            stableSort(filters, getComparator(order, orderBy)).map((row, index) => (
              <RecentSearchCardView key={index} row={row} handleApply={handleApply} />
            ))
          ) : (
            <Box style={{ padding: '50px 0' }}>
              {loadsFetched ? (
                <NoRecordFound>{'You have Created No filters Yet!'}</NoRecordFound>
              ) : (
                <NoRecordFound>{'Fetching Filters...'}</NoRecordFound>
              )}
            </Box>
          )}
        </Box>
      )}

      {openDialog && (
        <AddEditLoadFilter
          open={openDialog}
          onCloseDialog={handleCloseDialog}
          setCurrentTab={setCurrentTab}
          setPage={setPage}
        />
      )}
      {openViewDialog && <LoadDetailView open={openViewDialog} onCloseDialog={handleCloseViewDialog} />}

      <ConfirmDialog
        open={bidDialog}
        title={`Bid for ${selectedLoad && selectedLoad.origin && selectedLoad.origin.name} to ${selectedLoad &&
          selectedLoad.destination &&
          selectedLoad.destination.name}`}
        content={bidContent()}
        btnLabels={{ cancel: 'Cancel', confirm: 'Bid' }}
        onClose={handleBidClose}
        onConfirm={handleBidSend}
      />

      <ConfirmDialog
        open={callDialog}
        title={`Call +1 ${selectedLoad && selectedLoad.company_phone}`}
        content="You don't have an app to call. Copy the number instead."
        btnLabels={{
          cancel: 'Cancel',
          confirm: copyClicked ? 'Copied' : 'Copy',
        }}
        onClose={handleCallClose}
        onConfirm={handleCallCopy}
      />

      <ConfirmDialog
        open={openConfirmDialog}
        title={`Confirm book ${selectedLoad && selectedLoad.origin && selectedLoad.origin.name} to ${selectedLoad &&
          selectedLoad.destination &&
          selectedLoad.destination.name}`}
        content={'Are you sure, you want to book this load?'}
        onClose={handleCancelDelete}
        onConfirm={handleConfirmBook}
      />

      <ConfirmDialog
        open={openRequestDialog}
        title={
          <React.Fragment>
            <span style={{ color: '#666666' }}>Mark Load Status</span>
          </React.Fragment>
        }
        content={
          <React.Fragment>
            <span style={{ fontSize: 18 }}>
              Are you sure, you want to move this load to <b>In Progress</b>?
            </span>
          </React.Fragment>
        }
        onClose={handleCloseRequestedDialog}
        onConfirm={() => {
          ongoingOrRejectAction('Ongoing');
          handleCloseRequestedDialog();
        }}
      />

      <ConfirmDialog
        open={openRejectDialog}
        title={
          <React.Fragment>
            <span style={{ color: '#666666' }}>Mark Load Status</span>
          </React.Fragment>
        }
        content={
          <React.Fragment>
            <span style={{ fontSize: 18 }}>
              Are you sure, you want to move this load to <b>Rejected</b>?
            </span>
          </React.Fragment>
        }
        onClose={handleCloseRejectedDialog}
        onConfirm={() => {
          ongoingOrRejectAction('Rejected');
          handleCloseRejectedDialog();
        }}
      />

      <UploadDedicatedLoadsDialog
        open={uploadDialogOpen}
        onClose={handleUploadDialogClose}
        handleUploadDialogClose={handleUploadDialogClose}
        handleLoadType={handleLoadType}
      />
    </Box>
  );
};

export default Loadboard;
